// @flow
import styled from 'styled-components';
import { pb } from 'styled-components-spacing';
import Grid from 'styled-components-grid';

import { Pagination } from '@components';

import theme from '@theme';

export const StyledPagination = styled(Pagination)`
  ${pb(4.5)}
  display: flex;
`;

export const StyledWrapper = styled.div``;

export const StyledResultListContainer = styled(Grid.Unit)`
  justify-content: center;
`;

export const StyledCardsMapContainer = styled(Grid)`
  max-width: 1500px;
  margin: 0 auto;
`;

export const StyledMapWrapper = styled(Grid.Unit)`
  & > div {
    position: sticky;
    top: ${theme.spacing['5']};
    height: calc(100vh - ${theme.spacing['5']});
  }
`;
